module.exports = __webpack_public_path__ + "img/yw_fybx.4b3900f9.svg";